var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoNotUsed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2804 21.7052C12.4784 20.685 12 19.3984 12 18C12 14.6863 14.6863 12 18 12C19.3984 12 20.685 12.4784 21.7052 13.2804L13.2804 21.7052ZM14.7619 23.0521C15.696 23.652 16.8074 24 18 24C21.3137 24 24 21.3137 24 18C24 16.8074 23.652 15.696 23.0521 14.7619L14.7619 23.0521ZM10 18C10 13.5817 13.5817 10 18 10C22.4183 10 26 13.5817 26 18C26 22.4183 22.4183 26 18 26C13.5817 26 10 22.4183 10 18Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNotUsed);
export default __webpack_public_path__ + "static/media/ico-not-used.5047fbfbe25ac5161300b4940422c6b3.svg";
export { ForwardRef as ReactComponent };